$('.ajax_loadmore').on('click', function(event){
	event.preventDefault();

	var button = $(this),
	data = {
		'action': 'loadmore',
		'query': ajax_object.posts, // that's how we get params from wp_localize_script() function
		'page' : ajax_object.current_page
	};

	$.ajax({ // you can also use $.post here
		url : ajax_object.ajax_url, // AJAX handler
		data : data,
		type : 'POST',
		beforeSend : function ( xhr ) {
			button.text('Loading...'); // change the button text, you can also add a preloader image
		},
		success : function( data ){
			if( data ) {
				button.text( 'More posts' ).before(data);
				ajax_object.current_page++;

				history.pushState(null, null, ajax_object.blog_page + 'page/' + ajax_object.current_page);
				document.title = 'Blog - Page ' + ajax_object.current_page;
				if ( ajax_object.current_page == ajax_object.max_page )
					button.remove(); // if last page, remove the button
			} else {
				button.remove(); // if no data, remove the button as well
			}
		}
	});
});
